import { useEffect } from 'react';

import useDetectKeyboardOpen from 'use-detect-keyboard-open';

/**
 * Custom hook to handle keyboard-aware input behavior.
 * Automatically scrolls the active input element into view when the keyboard opens.
 * @returns null (this hook is used for side effects only).
 */
const useKeyboardAwareInput = () => {
  const isKeyboardOpen = useDetectKeyboardOpen();

  useEffect(() => {
    const activeElement = document?.activeElement as
      | HTMLElement
      | null
      | undefined;

    if (isKeyboardOpen && activeElement && activeElement.tagName === 'INPUT') {
      setTimeout(() => {
        activeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 124);
    }
  }, [isKeyboardOpen]);

  return null;
};

export default useKeyboardAwareInput;
